import { BasicInput } from '../../../components/BasicInput'

export default function CustomerDetails() {
  return (
    <div>
      <p className="mb-5 mt-8 text-sm font-semibold text-black04">
        Informações pessoais
      </p>
      <div className="grid grid-cols-inputs gap-x-4 gap-y-8">
        <BasicInput name="name" label="Nome" disabled />
        <BasicInput name="birthDate" label="Data de nascimento" disabled />
        <BasicInput name="phone" label="Número de telefone" disabled />
        <BasicInput name="email" label="E-mail" disabled />
        <BasicInput name="cpf" label="CPF" disabled />
      </div>
      <p className="mb-5 mt-8 text-sm font-semibold text-black04">Endereço</p>
      <div className="grid grid-cols-inputs gap-x-4 gap-y-8">
        <BasicInput name="address.zipCode" label="CEP" disabled />
        <BasicInput name="address.neighborhood" label="Bairro" disabled />
        <BasicInput name="address.city" label="Cidade" disabled />
        <BasicInput name="address.street" label="Rua" disabled />
        <BasicInput name="address.number" label="Número" disabled />
        <BasicInput name="address.complement" label="Complemento" disabled />
        <BasicInput name="address.state" label="UF" disabled />
      </div>
      <p className="mb-5 mt-8 text-sm font-semibold text-black04">
        Informações bancárias
      </p>
      <div className="grid grid-cols-inputs gap-x-4 gap-y-8">
        <BasicInput name="bankAccount.bank" label="Banco" disabled />
        <BasicInput name="bankAccount.agency" label="Agencia" disabled />
        <BasicInput name="bankAccount.account" label="Conta" disabled />
      </div>
    </div>
  )
}
